// extracted by mini-css-extract-plugin
export var avatarContainer = "_bi-0";
export var avatarTypingWave = "_bi-i";
export var gray = "_bi-f";
export var green = "_bi-c";
export var icon = "_bi-9";
export var image = "_bi-1";
export var lg = "_bi-6";
export var md = "_bi-5";
export var presenceDot = "_bi-b";
export var red = "_bi-d";
export var sm = "_bi-4";
export var status = "_bi-a";
export var typingDot = "_bi-h";
export var typingPill = "_bi-g";
export var xl = "_bi-7";
export var xs = "_bi-3";
export var xxl = "_bi-8";
export var xxs = "_bi-2";
export var yellow = "_bi-e";